// UserMenu.tsx — قائمة المستخدم (الملف الشخصيّ + تسجيل الخروج). `extraItems` اختياريّ (افتراضيًّا
// بلا شيء، فسلوك رأس الإدارة الحاليّ لا يتغيّر إطلاقًا) — يُستخدَم من OwnerTopBar فقط لإضافة
// «إحصائياتي» (+مُبدِّل البوابة على الجوال) دون تكرار منطق الخروج/الأفاتار في مكوّن منفصل
// (Owner_Portal_UX_Redesign_Plan_2026-07-12.md §3.1/§3.2).
import { LogOut, UserCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Avatar, AvatarFallback } from '../components/ui/avatar';
import { Button } from '../components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../components/ui/dropdown-menu';
import { useAuth } from '../auth/AuthContext';

interface UserMenuProps {
	extraItems?: ReactNode;
}

export function UserMenu({ extraItems }: UserMenuProps = {}) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { userName, logout } = useAuth();

	const handleLogout = () => {
		logout();
		navigate('/login', { replace: true });
	};

	const initials = (userName || '?').trim().slice(0, 2).toUpperCase();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="rounded-full" aria-label="user-menu">
					<Avatar className="size-7">
						<AvatarFallback className="bg-primary text-primary-foreground text-xs">{initials}</AvatarFallback>
					</Avatar>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-52">
				<DropdownMenuLabel className="truncate">{userName || t('shell.user', 'المستخدم')}</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={() => navigate('/profile')}>
					<UserCircle className="size-4" />
					{t('shell.profile', 'الملف الشخصيّ')}
				</DropdownMenuItem>
				{extraItems}
				<DropdownMenuSeparator />
				<DropdownMenuItem variant="destructive" onClick={handleLogout}>
					<LogOut className="size-4" />
					{t('shell.logout', 'تسجيل الخروج')}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
